export class OfficeAccessControls {
    adminsAccess:any;
	agentsAccess:any;
	medSpecialistsAccess:any;
	shopAccess:any;
	templatesAccess:any;
	scheduleMsgsAccess:any;
	formsAccess:any;
}
